export default __webpack_public_path__ + "static/media/External_link.5a1b578d.svg";